import { LOG_LEVEL_ENV_VAR, LOG_PREFIX } from "./constants.js";
const LOG_LEVEL_PRIORITY = {
    debug: 0,
    info: 1,
    warn: 2,
    error: 3,
};
function getLogLevel() {
    const env = process.env[LOG_LEVEL_ENV_VAR]?.toLowerCase();
    if (env && env in LOG_LEVEL_PRIORITY) {
        return env;
    }
    return "warn";
}
function shouldLog(level) {
    return LOG_LEVEL_PRIORITY[level] >= LOG_LEVEL_PRIORITY[getLogLevel()];
}
export class Logger {
    static _nextCommandId = 0;
    static _commandStartTimes = new Map();
    static formatMessage(message) {
        return `${LOG_PREFIX} ${message}`;
    }
    static warn(message, ...args) {
        if (!shouldLog("warn"))
            return;
        console.warn(Logger.formatMessage(message), ...args);
    }
    static error(message, ...args) {
        if (!shouldLog("error"))
            return;
        console.error(Logger.formatMessage(message), ...args);
    }
    static debug(message, ...args) {
        if (!shouldLog("debug"))
            return;
        console.warn(Logger.formatMessage(message), ...args);
    }
    static info(message, ...args) {
        if (!shouldLog("info"))
            return;
        console.warn(Logger.formatMessage(message), ...args);
    }
    static toolInvocation(toolName, args) {
        Logger.warn(`Tool "${toolName}" raw args:`, JSON.stringify(args, null, 2));
    }
    static toolParsedArgs(prompt, model, sandbox, changeMode) {
        Logger.warn(`Parsed prompt: "${prompt}"\nmodel: ${model ?? "default"}, sandbox: ${sandbox ?? false}, changeMode: ${changeMode ?? false}`);
    }
    static commandExecution(command, args) {
        const commandId = Logger._nextCommandId++;
        Logger._commandStartTimes.set(commandId, Date.now());
        Logger.warn(`[cmd:${commandId}] Starting: ${command} ${args.map((arg) => `"${arg}"`).join(" ")}`);
        return commandId;
    }
    static commandComplete(commandId, exitCode, outputLength) {
        const startTime = Logger._commandStartTimes.get(commandId);
        const elapsed = startTime ? ((Date.now() - startTime) / 1000).toFixed(1) : "?";
        Logger.warn(`[cmd:${commandId}] [${elapsed}s] Process finished with exit code: ${exitCode}`);
        if (outputLength !== undefined) {
            Logger.warn(`[cmd:${commandId}] Response: ${outputLength} chars`);
        }
        Logger._commandStartTimes.delete(commandId);
    }
    static checkNodeVersion(minMajor = 20) {
        const major = parseInt(process.versions.node.split(".")[0], 10);
        if (major < minMajor) {
            Logger.error(`Node.js v${process.versions.node} detected — v${minMajor}+ required. ` +
                `Some providers (e.g., gemini-cli) use ES2024 features that will crash on older runtimes.`);
        }
    }
}
//# sourceMappingURL=logger.js.map